import { createContext } from 'react';

const BookAppearanceModifiersContext = createContext({
  resetBookStyling: () => {},
  setLastFontSizeWasFit: () => {},
  setPreviousFontSize: () => {},
});

export default BookAppearanceModifiersContext;
